import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../store/auth';

/** Gate for authenticated routes. While /api/me is in flight we show a splash
 * (don't flash the login screen); an anonymous visitor is sent to /login. */
export default function RequireAuth() {
  const status = useAuth((s) => s.status);
  if (status === 'loading') {
    return (
      <div
        className="min-h-screen grid place-items-center bg-ff-ivory text-ff-mute"
        data-testid="auth-loading"
      >
        <span className="font-mono text-[11px] uppercase tracking-widish">loading…</span>
      </div>
    );
  }
  if (status === 'anon') return <Navigate to="/login" replace />;
  return <Outlet />;
}
